/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-04-17 14:14:53
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-09-16 14:57:54
 * @FilePath: \newsmartmapout\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Watch from '../views/Watch.vue'
import forecast from '../views/forecast.vue'
import response from '../views/response.vue'
import Login from '../views/Login.vue'
import waringpage from '../views/waringpage.vue'
import store from '../store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/watch',
    name: 'Watch',
    component: Watch,
    meta: { requiresAuth: true }
  },
  {
    path: '/forecast',
    name: 'forecast',
    component: () => import('../views/forecast.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/response',
    name: 'response',
    component:()=>import('../views/response.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/waringpage',
    name: 'waringpage',
    component: ()=>import('../views/waringpage.vue')
  },
  {
    path: '/weaterFore',
    name: 'weaterFore',
    component: ()=>import('../views/weaterFore.vue')
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// src/router/index.js
router.beforeEach((to, from, next) => {
  // 检查目标路由是否需要登录
  if (to.meta.requiresAuth) {
    console.log();
  const isLoggedIn = store.state.isLogon; // 假设用localStorage存储登录状态
  if (!isLoggedIn) {
  next('/'); // 未登录，重定向到登录页面
  } else {
  next(); // 已登录，继续导航
  }
  } else {
  next(); // 不需要验证，直接导航
  }
  })

export default router
